import { useEffect, useState } from 'react';

const useDomElement = (selector, getAll) => {
  const [nodeElement, toggleNodeElement] = useState(null);

  useEffect(() => {
    let timer = 0;

    const interval = setInterval(() => {
      let node;

      if (getAll) {
        node = document.querySelectorAll(selector);
      } else {
        node = document.querySelector(selector);
      }

      if (node) {
        toggleNodeElement(node);
        clearInterval(interval);
      } else if (timer >= 10) {
        clearInterval(interval);
      }

      timer += 1;
    }, 300);

    return () => clearInterval(interval);
  }, [selector]);

  return nodeElement;
};

export default useDomElement;
